/** About Us */

'use strict'

$(document).ready(function () {
  // Trigger play/pause video on play/pause button clicked
  $('.video__buttons').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();

    let videoID = '#' + $(this).siblings('video').attr('id');

    if ($(this).hasClass('pause')) {
      // Play the video
      $(videoID).get(0).play();

      // Update the button icon to 'Pause' icon
      $(this).removeClass('pause');
      $(this).addClass('play');
      $(this).find('.play').addClass('d-none');
      $(this).find('.pause').removeClass('d-none');
    } else {
      // Pause the video
      $(videoID).get(0).pause();

      // Update the button icon to 'Play' icon
      $(this).addClass('pause');
      $(this).removeClass('play');
      $(this).find('.pause').addClass('d-none');
      $(this).find('.play').removeClass('d-none');
    }
  });


  // Our Team Carousel - Slick Initialization
  let ourTeamCarosuel = $(".our-team__carousel");
  ourTeamCarosuel.slick({
    centerMode: false,
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: $('.slick__prev--our-team'),
    nextArrow: $('.slick__next--our-team'),
    adaptiveHeight: true
  });

  ourTeamCarosuel.slick("slickSetOption", "accessibility", false);
  ourTeamCarosuel.slick("slickSetOption", "draggable", false);
  ourTeamCarosuel.slick("slickSetOption", "swipe", false);
  ourTeamCarosuel.slick("slickSetOption", "touchMove", false);


  // Featured News Carousel - Slick Initialization
  let featuredNewsNav = $('.featured-on__counter');
  let featuredNewsCarousel = $('.featured-on__carousel');

  featuredNewsCarousel.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
    // If currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
    let currentSlideNumber = (currentSlide ? currentSlide : 0) + 1;

    // Update current active slide number of navigation
    featuredNewsNav.html(currentSlideNumber + '/' + '<span>' + slick.slideCount + '</span>');
  });

  featuredNewsCarousel.slick({
    dots: false,
    arrows: true,
    infinite: true,
    variableWidth: true,
    centerMode: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: $('.slick__prev--featured-on'),
    nextArrow: $('.slick__next--featured-on'),
  });
});